export const shortNorPhoneRegex = /^[4|9][0-9]{7}$/;
export const longNorPhoneRegex = /^47[0-9]{8}$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
